import { useMutation } from '@tanstack/react-query';
import { adminApi } from 'src/services';

type OnboardPractitionerToWorkspacePayload = {
  org_uuid: string;
};

export type OnboardPractitionerToWorkspaceResponse = unknown;

export const useOnboardPractitionerToWorkspace = () => {
  return useMutation({
    mutationKey: ['onboardPractitionerToWorkspace'],
    mutationFn: (payload: OnboardPractitionerToWorkspacePayload) =>
      adminApi.post<OnboardPractitionerToWorkspaceResponse>(
        '/practitioner/onboard_workspace',
        payload
      ),
  });
};
